<template>
  <action-dispatcher action="product/getProduct" :parameters="$route.params.id">
    <div
      v-if="product"
      class="view-product-upsell-tree"
      id="view-product-upsell-tree"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center page-title mb-0">
          <span v-if="funnels.length">{{ funnels[0].name }}</span>
        </div>
        <div class="d-flex align-items-center">
          <div class="btn btn-outline-primary ml-3" @click="copyWidget">
            <i class="icon-code mr-3" />
            <span>
              Código do widget
            </span>
          </div>
        </div>
      </div>

      <hr class="mb-6" />

      <div v-if="loading" class="text-center p-9">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;" />
      </div>

      <action-dispatcher
        v-else
        action="funnel/getTree"
        ref="treeGetter"
        :parameters="{ id: $route.params.tree }"
      >
        <div class="row justify-content-center mx-md-n5">
          <div
            class="mb-lg-8 mb-6 col-md-4 col-6 px-md-8"
            v-for="(item, index) in funnels"
            :key="index"
          >
            <tree-item
              :id="item.id"
              :funnel="item"
              @delete="deleteItem(item.id)"
              @action-yes="newActionYes(item)"
              @action-no="newActionNo(item)"
              @new-step="newStep(item)"
              @edit="editItem(item)"
            />
          </div>
        </div>
      </action-dispatcher>
    </div>

    <responsive-modal v-model="modal">
      <upsell-modal
        :action="action"
        :previous="previousFunnel"
        :funnelToEdit="funnelToEdit"
        @refresh="refresh"
        @close="modal = false"
      />
    </responsive-modal>
  </action-dispatcher>
</template>

<script>
import TreeItem from "@/components/upsell/TreeItem.vue";
import UpsellModal from "@/components/upsell/UpsellModal.vue";
import copy from "copy-text-to-clipboard";
import { mapState } from "vuex";

export default {
  components: {
    UpsellModal,
    TreeItem
  },
  computed: {
    ...mapState("product", ["product", "products"]),
    ...mapState("funnel", ["funnels"])
  },
  data() {
    return {
      action: "",
      loading: false,
      modal: false,
      funnel: null,
      funnelToEdit: null,
      previousFunnel: null
    };
  },
  methods: {
    copyWidget() {
      let widget = `<iframe id="zeuspay-upsell-iframe"></iframe><script src="https://pay.${this.$config.domain}/static/js/upsell-client.js"><\/script>`;
      copy(widget);
      this.$message.success("Código copiado.");
    },
    editItem(v) {
      this.funnelToEdit = v;
      this.modal = true;
    },
    deleteItem(id) {
      this.loading = true;
      this.$store
        .dispatch("funnel/delete", id)
        .finally(() => (this.loading = false));
    },
    newStep(item, action = null) {
      this.funnelToEdit = null;
      this.previousFunnel = item;
      this.action = action;
      this.modal = true;
    },
    newActionYes(item) {
      this.newStep(item, "yes");
    },
    newActionNo(item) {
      this.newStep(item, "no");
    },
    refresh() {
      setTimeout(() => {
        this.$refs.treeGetter.dispatch();
      }, 500);
    }
  }
};
</script>
<style lang="scss" scoped>
.view-product-upsell-tree {
  a {
    text-decoration: none;
  }
  .box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #d2d0d8;
    border-radius: 4px;
    height: 232px;
    cursor: pointer;
    img {
      height: 54px;
      width: 54px;
    }

    &:hover {
      background: linear-gradient(148.5deg, #ee6469 -19.31%, #5576ec 100%);
      border-color: rgb(191, 92, 170);

      strong {
        color: white;
      }
    }
  }

  i {
    font-size: 24px;
  }
}
</style>
